import { defineAction } from '~/prix'
import { featureCollection, latitude, longitude, multiPolygon, polygon } from '~/prix/types/presets/geo'
import healthUnitEditCoverageAreaAction from './healthUnitEditCoverageArea.action.json' with { type: 'json' }
import { z } from 'zod'

const polygonOrMultiPolygon = z.union([polygon(), multiPolygon()])

const healthUnitEditCoverageAreaDefinition = defineAction({
  ...healthUnitEditCoverageAreaAction,

  input: z.object({
    delimitationPolygon: polygonOrMultiPolygon,
    delimitationId: z.number(),
    delimitationType: z.enum(['municipality']),
    featureCollection: featureCollection(
      z.union([polygon(), multiPolygon(), z.null()]),
      z.object({
        key: z.string(),
        cnes: z.string(),
        name: z.string(),
        latitude: latitude().nullish(),
        longitude: longitude().nullish(),
        kind: z
          .enum([
            'smartMapping',
            'deprecated',
            'manualDrawing',
            'authorityProvided',
            'openStreetMapSourced',
          ])
          .nullish(),
      }),
    ),
  }),
  output: z.object({
    success: z.boolean(),
  }),
})

export default healthUnitEditCoverageAreaDefinition
